import React from 'react'
import { TextProps, Text } from '@chakra-ui/react'

export const Bold = (props: TextProps) => <Text as="span" fontWeight={500} {...props} />
